import React from 'react';
import './ArticleCard.css';

const ArticleCardComponent = ({ articulo }) => {
  const { titulo, contexto, url, imagen, section, author } = articulo;

  return (
    <a 
      href={url} 
      target="_blank" 
      rel="noopener noreferrer" 
      className="article-card-link"
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <div className="article-card-compact">
        {imagen && (
          <div className="article-image-container">
            <img 
              src={imagen} 
              alt={titulo}
              className="article-image"
            />
          </div>
        )}
        <div className="article-content">
          <div className="article-header">
            {section && (
              <span className="article-section">{section}</span>
            )}
          </div>
          <h3 className="article-title">{titulo}</h3>
          <p className="article-context">{contexto}</p>
          {author && (
            <span className="article-author">Por {author}</span>
          )}
        </div>
      </div>
    </a>
  );
};

export default ArticleCardComponent;
